import { render, staticRenderFns } from "./HeaderIconsForGeneralBasket.vue?vue&type=template&id=1c2099c9&"
import script from "./HeaderIconsForGeneralBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsForGeneralBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderIconsForGeneralBasket.vue?vue&type=style&index=0&id=1c2099c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports